import React, { useContext } from 'react'
import ExpensePieChart from './pie-chart'
import ModalHeading from '../../../components/shared/modal-heading'
import VehicleExpenseTable from './expense-table'
import { AccountsContext } from '../../../components/context/account-context'

const DataMap = ({ data, searchTerm, setSearchTerm, loading, type, table }) => {
  const { attributes } = useContext(AccountsContext);
  return (
    <div>
      <div className="grid grid-cols-2 gap-6">
        {/* Totals */}
        <div className="p-3 border rounded-lg w-full gap-6">
          <ModalHeading>Total Expense Costs</ModalHeading>
          <div className="grid grid-cols-2 mt-10 w-full gap-6 gap-y-12">
            <div className="flex flex-col items-center gap-1">
              <h1 className="text-3xl text-[#4cafef] font-bold">{data?.totals?.fuel ?? 0}</h1>
              <h1 className="font-medium">Fuel Cost ({attributes?.currency})</h1>
            </div>
            <div className="flex flex-col items-center gap-1">
              <h1 className="text-3xl text-[#ff9800] font-bold">{data?.totals?.service ?? 0}</h1>
              <h1 className="font-medium">Services Cost ({attributes?.currency})</h1>
            </div>
            <div className="flex flex-col items-center gap-1">
              <h1 className="text-3xl text-[#4caf50] font-bold">{data?.totals?.others ?? 0}</h1>
              <h1 className="font-medium">Other Cost ({attributes?.currency})</h1>
            </div>
            <div className="flex flex-col items-center gap-1">
              <h1 className="text-3xl text-red-700 font-bold">{data?.totals?.total ?? 0}</h1>
              <h1 className="font-medium">Total Cost ({attributes?.currency})</h1>
            </div>
          </div>
        </div>

        {/* Pie chart */}
        <div className="border p-3 rounded-lg">
          <ModalHeading>Expense Costs</ModalHeading>
          <ExpensePieChart totals={data?.totals} attributes={attributes} />
        </div>

        {/* Table */}
        <div className="col-span-2">
          {type === 'category'
            ? table 
            : (
              <VehicleExpenseTable
                data={data?.expenses ?? []}
                globalFilter={searchTerm}
                onGlobalFilterChange={setSearchTerm}
                loadingData={loading}
                type={type}
                attributes={attributes}
              />
            )}
        </div>
      </div>
    </div>
  )
}

export default DataMap
